import { useContext, useEffect, useRef, useState } from "react";
import { createArticle, updateArticle } from "../CommonFunc";
import { EDITOR_MODE } from "../Constans";
import { useWindowSize } from "../effects";
import { CKEditor } from "ckeditor4-react";
import { AppContext } from "../../Context/AppContext";
import { SiteLayoutContext } from "../SiteLayout";

const Editor = (props) => {
	//contexts
	const { theme } = useContext(AppContext);
	const { setIsAdmin } = useContext(SiteLayoutContext);

	//variables
	const rawContent = props.content.find(
		(element) => element.ID === props.currentContentId
	);
	const id = rawContent?.ID;
	const parentId = rawContent?.ID_PAR;

	//states
	const [state, setState] = useState({ value: "<p>1</p>" });
	const [newHeader, setNewHeader] = useState(
		props.mode === EDITOR_MODE.create ? "" : rawContent?.HEADER
	);
	const [errors, setErrors] = useState([]);

	//refs
	const headerRef = useRef();

	//custom hooks
	const [windowWidth, windowHeight] = useWindowSize();
	const content = props.mode === EDITOR_MODE.edit ? rawContent?.CONTENT : null;

	//#region effects
	useEffect(() => {
		if (props.mode === EDITOR_MODE.edit) {
			setState((prev) => ({
				value: content,
			}));
		}
	}, [props.mode]);

	useEffect(() => {
		console.log("state=>", state);
	}, [state]);

	useEffect(() => {
		let editorContainer = document.getElementsByClassName("ql-editor")?.[0];
		if (!editorContainer) {
			return;
		}
		editorContainer.style = `height : ${
			window.innerHeight - editorContainer?.getBoundingClientRect().top - 10
		}px`;
	}, [windowHeight, windowWidth]);

	useEffect(() => {
		if (document.querySelector("iframe")) {
			document
				.querySelector("iframe")
				.contentWindow.document.querySelector(".cke_editable").style.fontSize =
				"16px";
		}
	}, []);
	//#endregion

	//#region functions
	const handleClick = () => {
		if (newHeader?.length === 0) {
			return;
		}
		if (props.mode === EDITOR_MODE.create) {
			createArticle(id, newHeader, state.value)
				.then((res) => {
					props.setOpenEditor({
						open: false,
						mode: EDITOR_MODE.create,
						createdArticleId: res[0].ID,
					});
				})
				.catch((error) => {
					props.setErrorDialog({
						open: true,
						message: error?.response?.data,
					});
				});
		} else if (props.mode === EDITOR_MODE.edit) {
			updateArticle(id, parentId, newHeader, state.value).then((id) => {
				props.setOpenEditor({
					open: false,
					mode: EDITOR_MODE.create,
				});
			});
			setIsAdmin(false);
		}
	};

	const hadleClose = () => {
		props.setOpenEditor({
			open: false,
			mode: EDITOR_MODE.create,
		});
	};
	//#endregion

	return (
		<div
			className='editor-wrapper'
			color={props.color}
			style={{
				fontSize: `${
					(16 / theme.scaleFactor) * theme.bodyCenterFontMultiplier
				}px`,
			}}
		>
			<div className='editor-header'>
				<div className='left-column'></div>
				<div className='center-column'>
					<div className='header' data-errorvalue={errors[0]}>
						<input
							ref={headerRef}
							type='text'
							value={newHeader}
							placeholder='Заголовок статьи'
							autoFocus
							onFocus={() => setErrors([])}
							data-errorvalue={errors[0]}
							onChange={(e) => {
								let result = e.target.value.slice(0, 50);
								setNewHeader(result);
							}}
						/>
						<div className='header-counter'>{newHeader?.length ?? 0}/50</div>
					</div>
				</div>
				<div className='right-column'></div>
			</div>
			<div className='editor-content'>
				<div className='left-column'></div>
				<div className='center-column'>
					<div className='text-editor'>
						<div className='site-editor-wrapper'>
							<CKEditor
								config={{
									height: `${window.innerHeight - 200}px`,
									versionCheck: false,
								}}
								initData={content}
								onInstanceReady={(ev) => {}}
								onDataReady={() => {
									if (document.querySelector("iframe")) {
										let iframeContent =
											document.querySelector("iframe").contentWindow.document;
										if (theme.color === "dark") {
											iframeContent.querySelector("body").style.cssText = `
												background-color: #313131;
												color: white;
												font-size: ${(20 / theme.scaleFactor) * theme.bodyCenterFontMultiplier}px;
												line-height: 1.42;
												margin: 0px`;
											let pElements = Array.from(
												iframeContent.getElementsByTagName("p")
											);
											pElements.map((i) => (i.style.cssText = `margin: 0px`));
										} else {
											iframeContent.querySelector("body").style.cssText = `
												font-size: ${(20 / theme.scaleFactor) * theme.bodyCenterFontMultiplier}px;
												line-height: 1.42;
												margin: 0px`;
											let pElements = Array.from(
												iframeContent.getElementsByTagName("p")
											);
											pElements.map((i) => (i.style.cssText = `margin: 0px`));
										}
									}
								}}
								onChange={(e) => {
									setState({ value: e.editor.getData() });
								}}
							/>
						</div>
					</div>
				</div>
				<div className='right-column'>
					<div className='action-panel'>
						<div
							className={`button`}
							onClick={handleClick}
							style={
								newHeader?.length === 0
									? { opacity: 0.5, pointerEvents: "none" }
									: {}
							}
						>
							Сохранить
						</div>
						<div className='button' onClick={hadleClose}>
							Закрыть
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Editor;
